import { getUserSubscription } from '@requests/subscriptions';
import { queryKeySubscriptions } from '@utils/react-query-keys';
import { isEligibleForFreeTrialMax } from '@utils/subscription-utils';
import { useEffect, useState } from 'react';
import { useQuery } from '@tanstack/react-query';

const useIsEligibleForFreeMaxTrial = (user: any) => {
  const { data: subscriptionData } = useQuery({
    queryKey: [queryKeySubscriptions],
    queryFn: () => getUserSubscription(user),
    meta: { persist: true },
  });

  const [isEligibleForFreeMaxTrail, setIsEligibleForFreeMaxTrail] = useState<
    true | false | 'loading'
  >('loading');

  useEffect(() => {
    if (subscriptionData) {
      const isEligible = isEligibleForFreeTrialMax(subscriptionData);

      setIsEligibleForFreeMaxTrail(isEligible);
    }
  }, [subscriptionData]);

  return [isEligibleForFreeMaxTrail];
};

export default useIsEligibleForFreeMaxTrial;
